import { RECURRING_BILLING_FREQUENCY } from 'customer-data-objects/lineItem/PropertyNames';
import { ANNUALLY } from 'customer-data-objects/product/BillingFrequency';
import { getMonthsPerBillingFrequency, isWeeklyOrBiweeklyBillingFrequency } from 'customer-data-properties/v2/utils/period';
import { isRecurring } from 'products-ui-components/utils/recurrence';
import { getBillingFrequencyFromMonths } from './calculations/recurringPricing';
import { getProperty } from './objectAccessors';
import { getLineItems } from './subject';
export function getLargestBillingCycleLength(maybeLineItems) {
  // Returns the highest billing cycle length given a list of line items
  const recurringLineItems = getLineItems(maybeLineItems).filter(isRecurring);
  if (!recurringLineItems.length) {
    return ANNUALLY;
  }
  const largestBillingPeriod = recurringLineItems.reduce((currentMax, lineItem) => {
    const recurringBillingFrequency = getProperty(lineItem, RECURRING_BILLING_FREQUENCY);
    if (isWeeklyOrBiweeklyBillingFrequency(recurringBillingFrequency)) {
      return currentMax;
    }
    return Math.max(currentMax, getMonthsPerBillingFrequency(recurringBillingFrequency));
  }, 0);
  const largestBillingFrequency = getBillingFrequencyFromMonths(largestBillingPeriod);
  return largestBillingFrequency !== null && largestBillingFrequency !== void 0 ? largestBillingFrequency : ANNUALLY;
}